// ============================================================
// ANSICHTSSACHE-AGENT – Das Ergebnis einer Server Action
// ============================================================
// EINE Form fuer alle Actions, die etwas melden: Erfolg mit dem,
// was der Aufrufer braucht, oder ein Satz, der beim Menschen
// ankommt. Bis zum 07.10.2026 gab es 35 lokale Fassungen davon
// (`{ success }`, `{ ok }`, `{ error }`, `{ fehler }`), und die
// Auswerter in `ui/dialog.tsx` und `lib/use-action.ts` kannten nur
// `error` — eine Action mit `{ ok: false, fehler }` galt dort als
// Erfolg.
//
// Fachliche Fehler (kein Recht, Beleg gesperrt, Betrag fehlt)
// kommen als `{ error }` zurueck und werden NICHT geworfen: im
// Produktionsbau ersetzt Next die Meldung eines geworfenen Fehlers
// durch einen allgemeinen Text mit Digest, und der Grund bleibt auf
// dem Server. Geworfen wird nur, was ein Programmierfehler ist.
//
//   export async function speichern(id: string): Promise<ActionResult<{ id: string }>> {
//     const access = await actionAccess("kunden", "edit");
//     if (!access.ok) return { error: access.error };
//     …
//     return { success: true, id };
//   }
//
// Aufrufer: `errorOf(ergebnis)` liefert den Satz oder `null` —
// unabhaengig davon, ob eine aeltere Action noch `fehler` oder
// `ok: false` sagt.
// ============================================================

export type ActionError = { success?: false; ok?: false; error: string; field?: string };

export type ActionResult<T extends object = Record<never, never>> =
  ({ success: true; error?: undefined } & T) | ActionError;

/** Der Fehlersatz eines Ergebnisses — oder `null`, wenn es keinen gibt. */
export function errorOf(result: unknown): string | null {
  if (!result || typeof result !== "object") return null;
  const r = result as {
    error?: unknown;
    fehler?: unknown;
    ok?: unknown;
    success?: unknown;
  };
  if (typeof r.error === "string" && r.error) return r.error;
  if (typeof r.fehler === "string" && r.fehler) return r.fehler;
  // `{ ok: false }` oder `{ success: false }` ohne Satz: ein Fehler
  // ohne Worte ist immer noch ein Fehler.
  if (r.ok === false || r.success === false) return "Das hat nicht geklappt.";
  return null;
}

/** Typwaechter fuer den Fehlerzweig. */
export function istFehler<T extends object>(result: ActionResult<T>): result is ActionError {
  return errorOf(result) !== null;
}
